import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionCreateCardTaskCodes = {
  AutomationV2ExecutionActionCreateCardTaskFailedToCreateTask: {
    code: 'automation-v2-execution-action/create-card-task-failed-to-create-task',
    explanation: `Erro ao criar uma subtarefa (task) no card.

**Causas comuns:**
- Erro de validação nos campos da tarefa
- Template de tarefa inválido

**Como diagnosticar:**
Verifique se os dados obrigatórios da tarefa estão sendo preenchidos.`,
    localizations: {},
    message: 'A automação não conseguiu criar a tarefa no processo.',
    supportingDocs: [
      {
        name: 'Ação de Criar Tarefa de Card',
        path: '/wiki/docs/automations/actions/create-card-task',
      },
    ],
  },
  AutomationV2ExecutionActionCreateCardTaskMissingCardId: {
    code: 'automation-v2-execution-action/create-card-task-missing-card-id',
    explanation: `ID do card é obrigatório no contexto da ação. O id do card é automaticamente passado pelo gatilho ou por ações anteriores.

**Causas comuns:**
- Variável cardId não resolvida
- Caso o valor do cardId seja mapeado manualmente, pode ter sido digitado incorretamente.
- Caso o valor do cardId não tenha sido mapeado, o \`context.card.id\` não está disponível.

**Como resolver:**
Corrija o mapeamento do ID do card.`,
    localizations: {},
    message:
      'Não foi possível criar a tarefa do card porque o ID do card está faltando. Verifique se o card existe no contexto da automação ou se foi digitado corretamente.',
    supportingDocs: [
      {
        name: 'Ação de Criar Tarefa de Card',
        path: '/wiki/docs/automations/actions/create-card-task',
      },
      {
        name: 'Informações Dinâmicas',
        path: '/wiki/docs/automations/informacoes-dinamicas',
      },
    ],
  },
  AutomationV2ExecutionActionCreateCardTaskMissingTemplateId: {
    code: 'automation-v2-execution-action/create-card-task-missing-template-id',
    explanation: `ID do template da tarefa não encontrado.

**Causas comuns:**
- Configuração incompleta da ação
- Template de tarefa removido

**Como resolver:**
Selecione um template de tarefa válido.`,
    localizations: {},
    message:
      'Não foi possível criar a tarefa do card porque o ID do template está faltando. Verifique se o template existe no contexto da automação ou se foi digitado corretamente.',
    supportingDocs: [
      {
        name: 'Ação de Criar Tarefa de Card',
        path: '/wiki/docs/automations/actions/create-card-task',
      },
      {
        name: 'Informações Dinâmicas',
        path: '/wiki/docs/automations/informacoes-dinamicas',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
